import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  footerBannerSec: {
    marginBottom: 60,
    '@media (max-width: 767px)': {
      marginBottom: 30,
    }
  },
  footerBannerLink: {
    display: 'block',
    borderRadius: 30,
    overflow: 'hidden',
    "&>img": {
      transition: 'transform 0.3s ease',
    },
    "&:hover img": {
      transform: 'scale(1.02)',
    }
  }
}));
